/*
 * Public API Surface of vj-paginator
 */

export * from './lib/vj-paginator.service';
export * from './lib/vj-paginator.component';
export * from './lib/vj-paginator.module';
